<template>
    <div class="header">
        <h1 class="title title--uppercase header__title">
            Крупнейший сервис <wbr>по сохранению памяти<wbr> о людях в России
        </h1>

        <div class="header__content">
            <ul class="header__list">
                <li class="header__item" v-for="(item, index) in items" :key="index" :class="item.id">
                    <a :href="item.pageLink" class="header__img-block">
                        <div class="header__img-text-wrapper">
                            <span class="header__img-text-count">{{ item.count.toLocaleString('ru-RU') }}</span>
                            <span class="header__img-text">{{ item.titleCount }}</span>
                        </div>
                        <img :src=item.img class="header__img" alt="img" />
                    </a>
                    <a :href="item.pageLink" class="header__counter">
                        <span class="header__title-card">{{ item.title }}</span>
                        <span class="header__text-card">{{ item.text }}</span>
                    </a>
                    <div class="header__btn-group">
                        <button @click="reroutPage(item)"
                            class="footer__card btn--big btn--main-bg">{{ item.textBtn }}<span class="header__subtext">
                                {{ item.subTextBtn }}</span></button>

                        <router-link v-if="(item.id === 'pages' || item.id === 'tree') && isRegistered == false"
                            class="link" :to="{ name: 'registration', query: $route.query }">
                            <span>{{ item.textLink }}</span>
                        </router-link>
                        <router-link v-if="(item.id === 'pages' || item.id === 'tree') && isRegistered" class="link"
                            :to="{ name: 'profile-user', query: $route.query }">
                            <span>{{ item.textLink }}</span>
                        </router-link>
                        <router-link v-if="item.id === 'memorial'" class="link"
                            :to="{ name: 'place-feedback', params: { title: $lang('placeLanding.feedback.title') } }">
                            <span>{{ item.textLink }}</span>
                        </router-link>
                    </div>
                </li>


            </ul>
            <div class="footer__text-wrapper">
                <img :src="star" alt="star" />
                <div class="footer__bottom-container">
                    <span class="footer__text-top">{{ footerTextTop }}</span>
                    <span class="footer__text-bottom">{{ footerTextBottom }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WelcomeHeaderIconArrow from "./WelcomeHeaderIconArrow.vue";
import Table from '../../../img/welcome/page.png';
import Tree from '../../../img/welcome/tree.png';
import Place from '../../../img/welcome/place.png';
import star from '../../../img/welcome/star.svg';
import mobileMenu from "../header/mixins/MobileMenu";
import ApiService from "../../api/api";

export default {
    name: 'WelcomeHeader',
    components: { WelcomeHeaderIconArrow },
    data() {
        return {
            star,
            items: [
                {
                    count: 0,
                    titleCount: 'Страниц \nуже создано',
                    img: Table,
                    title: "СТРАНИЦЫ \nПАМЯТИ",
                    text: "Это интерактивная страница в сети, на которой вы сможете сохранить воспоминания и историю близкого человека",
                    textBtn: "Создать страницу",
                    textLink: "Регистрация",
                    id: "pages",
                    href: '/create/tariffs',
                    pageLink: '/page'
                },
                {
                    count: 0,
                    titleCount: 'Персон создали \nпользователи в своих древах',
                    img: Tree,
                    title: "ГЕНЕАЛОГИЧЕСКОЕ ДРЕВО",
                    text: "Загляните в прошлое и создайте полную картину вашей родословной. Бесплатно постройте генеалогическое древо семьи онлайн в «Коде Памяти»",
                    textBtn: "Создать древо ",
                    subTextBtn: "бесплатно",
                    textLink: "Регистрация",
                    id: "tree",
                    href: '/cabinet/tree',
                    pageLink: '/familytree'
                },
                {
                    count: 0,
                    titleCount: 'Памятных мест РФ \nописаны с QR-кодом',
                    img: Place,
                    title: "ПАМЯТНЫЕ \nМЕСТА",
                    text: "Лучший инструмент для сохранения памяти и создания точек притяжения туристов, гостей и местных жителей в вашем городе",
                    textBtn: "Смотреть места",
                    textLink: "Подать заявку",
                    id: "memorial",
                    href: '/place#examples',
                    pageLink: '/place'
                },

            ],
            footerTextTop: 'Наш сервис помогает сохранить родовую историю для будущих поколений, формируя уважительное отношение к своей семье и укрепляя ценность сохранения памяти. Мы также активно способствуем сохранению исторического наследия, фиксируя и передавая информацию о памятных местах и значимых событиях прошлого.',
            footerTextBottom: 'Хранение персональных данных осуществляется в соответствии с Федеральным законом "О персональных данных" от \n27.07.2006 N 152-ФЗ',
            domain: window.laravel.appUrlByLocale,
            prefix: window.laravel.prefix,
        };
    },
    mounted() {
        this.fetchStats();
    },
    computed: {
        isRegistered() {
            return window.laravel.user != null;
        }
    },
    mixins: [mobileMenu],
    methods: {
        fetchStats() {
            ApiService.get('/statistics/common').then((response) => {
                const data = response.data;

                this.items.map((item) => {
                    switch (item.id) {
                        case 'pages':
                            item.count = data.pages ?? 0;
                            break;
                        case 'memorial':
                            item.count = data.memorials ?? 0;
                            break;
                        case 'tree':
                            item.count = data.familytreeLeaves ?? 0;
                            break;
                    }
                });
            });
        },
        reroutPage(item) {
            if (item.id === 'tree' && window.laravel.user == null) {
                this.$router.push({name: 'login', query: {redirect: '/cabinet/tree'}});
            }
            else {
                location.href = window.laravel.appUrlByLocale + window.laravel.prefix + item.href;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

.header__title {
    width: 100%;
    font-size: 50px;
    line-height: 130%;
    letter-spacing: -1.25px;
    font-weight: 600;

    @media(max-width: 900px) {
        font-size: 38px;
    }

    @media(max-width: 500px) {
        font-size: 26px;
    }
}

.header__content {
    margin-top: 2.6rem;
}

.header__list {
    margin: -1rem;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas: "a c b";

    @media(max-width: 900px) {
        grid-template-areas:
            "a c"
            "b b";
        grid-template-columns: 1fr 1fr;
    }

    @media(max-width: 500px) {
        grid-template-areas:
            "a" "c" "b";
        grid-template-columns: 1fr;
    }

}

.header__subtext {
    display: block;

    @media(max-width: 1200px) {
        display: none;
    }

    @media(max-width: 500px) {
        display: none;
    }

}

.header__item {
    cursor: pointer;
    box-sizing: border-box;
    margin: 12px;
    border-radius: 10px;
    border: 1px solid var(--unnamed, rgba(192, 201, 218, 0.31));
    padding: 24px;
    background: #f8f9fc;
    position: relative;

    &.page {
        grid-area: a;
    }

    &.tree {
        grid-area: c;
    }

    &.memorial {
        grid-area: b;
    }
}

.header__img {
    position: relative;
    width: 100%;
    border-radius: 10px;
    background: #fff;

    @media (max-width: 900px) {
        max-width: 362px;
    }
}

.header__img-block {
    height: 350px;
    overflow: hidden;
    //margin-top: 40px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    background: #fff;
    border-radius: 10px;
}

.header__img-text-wrapper {
    display: flex;
    align-items: center;
    position: absolute;
    top: 40px;
    left: 40px;
    z-index: 2;
}

.header__img-text-count {
    font-size: 26px;
    font-weight: 600;
    color: #00B4FF;
    font-family: 'Montserrat';
}

.header__img-text {
    white-space: pre-wrap;
    margin-left: 10px;
    font-size: 12px;
    font-weight: 400;
    color: #00B4FF;
    line-height: 12px;

    @media (max-width: 390px) {
        max-width: 120px;
    }
}

.header__title-card {
    white-space: pre-wrap;
    font-size: 28px;
    font-weight: 600;
    color: #353D51;
    word-break: normal;
    padding: 10px 0;
    font-family: "Montserrat";
    letter-spacing: -1.25px;
    line-height: 36.4px;

    @media(max-width: 900px) {
        font-size: 24px;
    }

    @media(max-width: 500px) {
        max-width: 326px;
        font-size: 24px;
        white-space: normal;
    }
}

.header__text-card {
    font-size: 16px;
    font-weight: 400;
    color: #4E4E4E;
    line-height: 19.2px;
    font-family: 'HelveticaNeue';
}

.footer__card {
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    gap: 4px;
}


.link span {
    margin: 0;
}

.link {
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}

.link::after {
    margin-left: 8px;
}

.footer__bottom-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.footer__text-top {
    font-size: 16px;
    font-weight: 400;
    color: #4E4E4E;

    @media(max-width: 900px) {
        font-size: 14px;
    }

    @media(max-width: 500px) {
        font-size: 12px;
    }
}

.footer__text-bottom {
    font-size: 16px;
    font-weight: 400;
    color: #9FA7BC;

    @media(max-width: 900px) {
        font-size: 14px;
    }

    @media(max-width: 500px) {
        font-size: 12px;
    }
}

.footer__text-wrapper {
    box-sizing: border-box;
    margin: 18px 0 16px 0;
    gap: 16px;
    display: flex;
    white-space: pre-wrap;
    align-items: flex-start;
    border-radius: 10px;
    border: 1px solid var(--unnamed, rgba(192, 201, 218, 0.31));
    padding: 24px;
    background: #FFF;
    box-shadow: 0 40px 100px 0 rgba(195, 195, 195, 0.26);
    position: relative;
}

.header__counter {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 1.1rem 0 1.8rem;
    max-height: 250px;
}

.counter__title {
    color: #00B4FF;
    font-size: 4rem;
}

.counter__text {
    color: #353D51;
    line-height: 120%;
    font-weight: 400;
    width: 16rem;
}

.counter__icon {
    position: absolute;
    bottom: 1.5rem;
    right: 2.5rem;
    cursor: pointer;
}
</style>
